export enum Interval {
  None = 0,
  Weekly = 1,
  Monthly = 2,
  //Quarterly = 3,
  Yearly = 4,

  Quarterly = 100
}

export const IntervalMapping: Record<Interval, string> = {
  [Interval.None]: 'Never',
  [Interval.Weekly]: 'Weekly',
  [Interval.Monthly]: 'Monthly',
  [Interval.Yearly]: 'Yearly',
  [Interval.Quarterly]: 'Quarterly'
};

export const IntervalAbbreviationMapping: Record<Interval, string> = {
  [Interval.None]: '-',
  [Interval.Weekly]: 'Wk',
  [Interval.Monthly]: 'Mth',
  [Interval.Yearly]: 'Yr',
  [Interval.Quarterly]: 'Qtr'
};

export const IntervalPluralMapping: Record<Interval, string> = {
  [Interval.None]: '-',
  [Interval.Weekly]: 'Weeks',
  [Interval.Monthly]: 'Months',
  [Interval.Yearly]: 'Years',
  [Interval.Quarterly]: 'Quarters'
};
